import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Button, Space } from "antd";
import {
  CloseCircleOutlined,
  CloseOutlined,
  MoreOutlined,
  PlusOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import styles from "./column.module.css"; // Assume styles are in this file
import FormLayout, { FormContent, FormFooter, FormHeader } from "../form/form";
import { FormRow } from "../form/form-row";

interface Column {
  key: string;
  title: string;
  hidden: boolean;
}

interface ColumnManagerProps {
  columns: Column[];
  initialColumns: Column[];
  onDragEnd: (result: any) => void;
  onToggleColumn: (key: string) => void;
  onResetColumns: () => void;
  onSave: () => void;
  onCancel: () => void;
}

const ColumnManager: React.FC<ColumnManagerProps> = ({
  columns,
  onDragEnd,
  onToggleColumn,
  onResetColumns,
  onSave,
  onCancel,
}) => {
  return (
    <FormLayout>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="columns">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className={styles.columnOptionsWrapper}
            >
              <FormHeader>
                <CloseOutlined
                  style={{
                    position: "absolute",
                    top: 23,
                    left: 15,
                    color: "white",
                  }}
                  onClick={onCancel}
                />

                <div
                  style={{
                    display: "flex",
                    alignItems: "space-between",
                    marginTop: "28px",
                  }}
                >
                  <p style={{ color: "#fff", fontSize: "1.2rem" }}>
                    Column Options
                  </p>

                  {/* Reset Button */}
                  <Button
                    type="text"
                    icon={<ReloadOutlined />}
                    onClick={onResetColumns}
                    style={{
                      color: "#fff",
                      right: 10,
                      top: 60,
                      position: "absolute",
                    }}
                  >
                    Reset
                  </Button>
                </div>
              </FormHeader>

              <FormContent className={styles.marginTop}>
                {/* Draggable Columns */}
                {columns.map((col, index) => (
                  <Draggable
                    key={col.key}
                    draggableId={col.key}
                    index={index}
                    isDragDisabled={col.hidden}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                          opacity: col.hidden ? 0.5 : 1,
                          ...provided.draggableProps.style,
                        }}
                        className={styles.columnOption}
                      >
                        <div
                          className={styles.columnHover}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            padding: "10px 5px",
                          }}
                        >
                          <div>
                            <span>
                              <MoreOutlined className={styles.thickIcon} />
                              <MoreOutlined
                                className={styles.thickIcon}
                                style={{ position: "relative", right: "8px" }}
                              />
                            </span>
                            <span style={{ fontSize: "15px" }}>
                              {col.title}
                            </span>
                          </div>
                          <Space>
                            {!col.hidden && (
                              <CloseCircleOutlined
                                className={styles.thickerIcon}
                                style={{ cursor: "pointer" }}
                                onClick={() => onToggleColumn(col.key)}
                              />
                            )}
                            {col.hidden && (
                              <PlusOutlined
                                style={{ cursor: "pointer", opacity: 1 }}
                                onClick={() => onToggleColumn(col.key)}
                              />
                            )}
                          </Space>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
              </FormContent>
              <FormFooter className="formFooter">
                <FormRow className="formRow">
                  <Button
                    type="primary"
                    className="btnDimensions"
                    onClick={onSave}
                  >
                    Save
                  </Button>
                  <Button
                    type="primary"
                    className="btnDimensions"
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                </FormRow>
              </FormFooter>

              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </FormLayout>
  );
};

export default ColumnManager;
